import * as React from "react";
import { Icon } from "../Icon/icon";
import { DetailsHTMLAttributes } from "react";

export interface IExpanderProps {
  heading: string;
  isExpanded: boolean;
  cssClass?: string;
  icon?: string;
}

/**
 * Renders an HTML5 details element with the given children as its body. Anything can be rendered within body.
 * ```typescript
 * <Expander heading={'Click me'} isExpanded={false}>
 *  <MyComponent />
 *  <AnotherComponent />
 * </Expander>
 * ```
 */
export class Expander extends React.PureComponent<IExpanderProps> {
  static defaultProps = {
    cssClass: "",
  };

  public render() {
    const { cssClass, isExpanded, icon, heading, children } = this.props;
    const detailsAttributes = {
      className: `${BaseClassName} ${cssClass}`,
      open: isExpanded,
    } as DetailsHTMLAttributes<HTMLElement>;
    return (
      <details {...detailsAttributes}>
        <summary>
          {icon && <Icon iconType={icon} />}
          {heading}
          <span className={`${PlusMinusClassName}`} aria-hidden="true" />
        </summary>
        <div className="expand-block__content">{children}</div>
      </details>
    );
  }
}

//These two classnames are also used in ExpanderGroup.tsx
export const BaseClassName = "expand-block";
export const PlusMinusClassName = "expand-block__plusminus";
export const SummarySpanClassName = "summary-heading";
